import { type ReactNode } from 'react';
import { cn } from '~/utils';

interface EmptyStateProps {
  icon?: ReactNode;
  title: string;
  message: string;
  size?: 'page' | 'compact';
}

export function EmptyState({
  icon,
  title,
  message,
  size = 'page',
}: EmptyStateProps) {
  const isCompact = size === 'compact';

  return (
    <div
      className={cn(
        'bg-neut-bg-alt rounded-lg border border-neut-border text-center w-full flex flex-col items-center justify-center',
        isCompact ? 'p-6' : 'p-12'
      )}
    >
      {icon && (
        <div
          className={cn('mx-auto text-neut-400', isCompact ? 'mb-2' : 'mb-4')}
        >
          {icon}
        </div>
      )}
      <h3
        className={cn(
          'text-neut-prim font-semibold',
          isCompact ? 'text-sm mb-1' : 'text-lg mb-2'
        )}
      >
        {title}
      </h3>
      <p className={cn('text-neut-sec', isCompact ? 'text-sm' : undefined)}>
        {message}
      </p>
    </div>
  );
}
